import { Button, Dropdown, Grid } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  const items = [
    {
      key: 'en',
      label: 'English',
    },
    {
      key: 'es',
      label: 'Español',
    },
    {
      key: 'pt',
      label: 'Português',
    },
  ];

  const handleLanguageChange = ({ key }: { key: string }) => {
    i18n.changeLanguage(key);
  };

  const getLanguageLabel = (language: string) => {
    switch (language) {
      case 'en':
        return 'English';
      case 'es':
        return 'Español';
      case 'pt':
        return 'Português';
      default:
        return 'English';
    }
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleLanguageChange,
        selectedKeys: [i18n.language],
      }}
      placement="bottomRight"
    >
      <Button icon={<GlobalOutlined />}>
        {!isMobile && getLanguageLabel(i18n.language)}
      </Button>
    </Dropdown>
  );
};

export default LanguageSelector; 